<script setup>
  import { storeToRefs } from 'pinia';
  import { useRoute } from 'vue-router';
  import { computed, provide } from 'vue';
  import { RouterView } from 'vue-router';
  import Footer from './layout/Footer.vue';
  import Header from './layout/Header.vue';
  import { useUserStore } from "@/stores/user";
  import { useBreakpoints } from '@vueuse/core';
  import { useCheckoutStore } from '@/stores/checkout';
  import CheckoutActionBar from '@/views/checkouts/components/organisms/ActionBar.vue';

  const route = useRoute();
  const userStore = useUserStore();
  const checkoutStore = useCheckoutStore();

  const breakpoints = useBreakpoints({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
  });

  const isMobile = breakpoints.smaller('xl');
  provide('isMobile', isMobile);

  const isLessMd = breakpoints.smaller('md');
  provide('isLessMd', isLessMd);

  const isLessXl = breakpoints.smaller('xl');
  provide('isLessXl', isLessXl);

  const checkoutRouteNames = new Set(['checkout', 'payment']);
  const { isUploadStep, isBankTransferPaymentStep } = storeToRefs(checkoutStore);

  const showCheckoutActionBar = computed(() => {
    const upload = isUploadStep.value;
    const bankTransfer = isBankTransferPaymentStep.value;
    const isCheckoutRoute = checkoutRouteNames.has(route.name);

    return isCheckoutRoute && !bankTransfer && !upload;
  });
</script>

<template>
  <script src="https://cdn-eu.pagesense.io/js/insurancemarket/2286609555934602bbc2d5e546ffd8e0.js"></script>
  <script type="text/javascript">(function(w,s){var e=document.createElement("script");e.type="text/javascript";e.async=true;e.src="https://cdn-eu.pagesense.io/js/insurancemarket/2286609555934602bbc2d5e546ffd8e0.js";var x=document.getElementsByTagName("script")[0];x.parentNode.insertBefore(e,x);})(window,"script");</script>
  
  <div class="app" :class="{ 'theme-pro': userStore.isProTheme() }">
    <Header v-if="!userStore.isPanelIFrame()"/>

    <!-- route outlet, component matched by the route will render here -->
    <main>
      <RouterView />
    </main>

    <Footer v-if="!userStore.isPanelIFrame()" />

    <CheckoutActionBar v-if="showCheckoutActionBar" />
  </div>
</template>

<style lang="scss">
  // Sass entry point
  @import 'assets/sass/entry';
</style>
